export interface NavItem {
  path: string
  name: string
}

export const navItems: NavItem[] = [
  {
    path: './#features',
    name: 'features'
  },
  {
    path: './#ecosystem',
    name: 'ecosystem'
  },
  {
    path: './#pricing',
    name: 'pricing'
  }
]
